<template>
  <base-infinite-scroll :disabled="isLoading" @loadMore="loadLearningUnit">
    <b-row class="justify-content-md-center m-0">
      <b-col lg="10" xl="9" class="my-4">
        <div class="d-md-flex justify-content-md-end">
          <div class="mr-auto flex px-2">
            <SearchBar
              v-model="searchKeyWords"
              placeholder="Search micro-credentials here..."
              @reset="onSearchReset"
            />
          </div>

          <b-row no-gutters class="mt-3 mt-md-0">
            <b-col cols="6" md="auto">
              <explore-filter-button v-model="filter" class="mx-2" />
            </b-col>
            <b-col cols="6" md="auto">
              <explore-sort-button v-model="sort" class="mx-2" />
            </b-col>
          </b-row>
        </div>

        <explore-category-badge v-model="filter.categories" />

        <transition name="slide-fade--up" appear mode="out-in">
          <div v-if="isLoading" key="loading" class="d-flex justify-content-center p-4 m-3">
            <b-spinner label="Loading..." variant="dark" />
          </div>

          <!-- Learning unit list -->
          <div v-else key="displaying">
            <div v-if="hasSearchResult">
              <!-- <SearchResults v-if="extractSearchKeywords ||
              filterDateTime.start ||
              filterCategories.length
              " class="mt-4" :extract-search-keywords="extractSearchKeywords" :filter-date-time="filterDateTime"
              :filter-categories="filterCategories" />

              <ResetAllText v-if="extractSearchKeywords ||
                filterDateTime.start ||
                filterCategories.length
                " @reset="resetPage()" /> -->

              <LearningUnitCardList :items="learningUnits">
                <template v-slot:thumbnail="{ learningUnits: learningUnitsData = {} }">
                  <mc-explore-thumbnail
                    :key="`thumbnail--${learningUnitsData.item.id}`"
                    :learning-unit="learningUnitsData.item"
                  />
                </template>
                <template v-slot:list-detail="{ learningUnits: learningUnitsData = {} }">
                  <McExploreDetail key="learningUnitsData.item" :mc="learningUnitsData.item">
                  </McExploreDetail>
                </template>
              </LearningUnitCardList>

              <b-row v-if="isLoadMore" class="d-flex justify-content-center p-4 mb-2">
                <b-spinner label="Loading..." variant="dark" />
              </b-row>
            </div>

            <!-- Error message when not find search result -->
            <div v-else class="text-dark mr-auto px-2">
              <!-- <SearchResults class="mt-4" :extract-search-keywords="extractSearchKeywords" :filter-date-time="filterDateTime"
                :filter-categories="filterCategories" />
              <ResetAllText v-if="extractSearchKeywords ||
                filterDateTime.start ||
                filterCategories.length
                " @reset="resetPage()" /> -->
              <div class="my-4">
                Sorry, we couldn't find any results
                <span class="d-block">Try adjusting your search, Here are some ideas:</span>
              </div>
              <ul>
                <li>Make sure all words are spelled correctly</li>
                <li>Try different search terms</li>
                <li>Try more general search terms</li>
              </ul>
            </div>
          </div>
        </transition>
      </b-col>
    </b-row>
  </base-infinite-scroll>
</template>

<script>
/* Trigger event cross component */
// import { eventBus } from "../../../main";

/* Base Components */
// import { BaseLists } from "@/components/base-components";

/* Customized Components */
import SearchBar from './SearchBar';
// import SearchResults from "./SearchResults";
// import ResetAllText from "./ResetAllText";
import McExploreDetail from './McExploreDetail.vue';
import McExploreThumbnail from './McExploreThumbnail.vue';
import LearningUnitCardList from './LearningUnitCardList.vue';
import ExploreSortButton from './ExploreSortButton.vue';
import ExploreCategoryBadge from './ExploreCategoryBadge.vue';
/* Mixins */
import { userInfoMixin, datetimeMixin } from '@/mixins';
import { amplitudeMixin } from '@/mixins/amplitudeMixin';

/* Models */
import LearningUnit from '@/models/LearningUnit';

// import Section from "@/models/Section";
import { debounce, kebabCase, snakeCase } from 'lodash';

import ExploreFilterButton from './ExploreFilterButton.vue';
import Category from '@/models/Category';
import BaseInfiniteScroll from '@/components/base-components/BaseInfiniteScroll.vue';
export default {
  name: 'ListExploreLearningUnit',

  components: {
    // BaseLists,
    SearchBar,
    // SearchResults,
    // ResetAllText,
    McExploreDetail,
    McExploreThumbnail,
    LearningUnitCardList,
    ExploreSortButton,
    ExploreFilterButton,
    ExploreCategoryBadge,
    BaseInfiniteScroll
  },

  mixins: [userInfoMixin, datetimeMixin, amplitudeMixin],

  data() {
    return {
      /**
       * Keywords for searching learning unit
       * @type {String[]}
       */
      searchKeyWords: [],
      /**
       * Check if not found search key word
       * @type {Boolean}
       */
      hasSearchResult: true,
      /**
       * Date Time for filter LUs
       * @type {String, Object}
       */
      // filterDateTime: { start: null, end: null },

      filter: {
        categories: this.$route.query.categories || [],
        type: this.$route.query.type || 'all'
      },

      sort: this.$route.query.sort || null,
      /**
       * Categories and Sub-Categories for filter LUs
       * @type {String[]}
       */
      // filterCategories: [],

      /**
       * Learning unit data that recieved from fetch API
       * @type {Object[]}
       */
      learningUnits: [],

      /**
       * Reset all form data in modal
       * @type {Boolean}
       */
      resetModal: false,

      /**
       * Show/Hide spinner when fetching data
       * @type {Boolean}
       */
      isLoading: false,

      /**
       * Show/Hide spinner when fetching data
       * @type {Boolean}
       */
      isLoadMore: false,

      /**
       * Count amount of time lazy loading has been trigger
       * @type {Number}
       */
      countLazyLoading: 0,

      /**
       * state for check fetching more than 15 items
       * @type {Boolean}
       */
      toggleFetching: true,

      /**
       * Become true when no more learning unit to fetch,
       * Use to prevent fetching when no learning unit to fetch
       * @type {Boolean}
       */
      noMoreItem: false,
      pageSize: 15
    };
  },

  computed: {
    /**
     * Extract keywords to render on the results search
     * @return {String}
     */
    extractSearchKeywords() {
      return this.searchKeyWords.toString().split(',').join(', ');
    },

    /**
     * merge all filter and sort into object : keywords, start-end datetime, start point of lazy-loading
     * @return {Object}
     */
    fetchParams() {
      const { sort } = this;

      const filter = {
        _sort: sort
        // start_at: this.filterDateTime.start
        //   ? new Date(this.filterDateTime.start).toISOString()
        //   : null,
        // end_at: this.filterDateTime.end
        //   ? new Date(this.filterDateTime.end).toISOString()
        //   : null,
      };

      if (this.searchKeyWords.length) this.$set(filter, 'name', this.searchKeyWords);

      if (this.filter.categories.length)
        this.$set(
          filter,
          'categories',
          this.filter.categories.map((slug) => slug)
        );

      if (this.filter.type !== 'all')
        this.$set(filter, 'type', snakeCase(this.filter.type).toUpperCase());

      // if (this.filterDateTime.start === null) {
      //   delete filter.start_at;
      //   delete filter.end_at;
      // }
      // if (this.filterDateTime.end === null) delete filter.end_at;

      return filter;
    }
  },

  watch: {
    /**
     * fetch on searchKeywords change
     */
    searchKeyWords: {
      async handler() {
        await this.fetchOnStateChanged();
      },
      deep: true
    },

    /**
     * fetch on start-end datetime change
     * if condition to prevent over fetch when clicking reset all
     */
    // filterDateTime: {
    //   handler(filterDateTime) {
    //     if (!filterDateTime.start) return;
    //     this.fetchLearningUnitsWithFilter();
    //   },
    //   deep: true,
    // },

    /**
     * fetch on categories change
     * if condition to prevent over fetch when clicking reset all
     */
    filter: {
      handler: 'onFilterChanged',
      deep: true
    },

    sort: {
      handler: 'onSortChanged',
      deep: true
    }
  },

  async created() {
    this.loadLearningUnit = debounce(this.loadLearningUnit, 500);

    await this.fetchCategories();
  },

  async beforeDestroy() {
    await LearningUnit.deleteAll();
  },

  methods: {
    onSearchReset() {
      this.searchKeyWords = [];
    },

    async onFilterChanged({ type, categories = [] } = {}) {
      this.$router.push({
        query: { ...this.$route.query, type: kebabCase(type), categories }
      });

      await this.fetchOnStateChanged();
    },

    async onSortChanged(sort) {
      const { query } = this.$route;

      if (query.sort !== sort) {
        this.$router.push({
          query: { ...query, sort }
        });
      }

      await this.fetchOnStateChanged();
    },

    async fetchOnStateChanged() {
      this.isLoading = true;
      this.resetLoadState();
      let start = 0;
      let limit = this.pageSize;
      if (this.countLazyLoading > 0) start = this.pageSize * this.countLazyLoading;

      try {
        await this.fetchLearningUnits(start, limit);
      } catch (error) {
        this.$toast('Cannot load data, please try again');
      } finally {
        this.isLoading = false;
      }
    },

    resetLoadState() {
      this.hasSearchResult = true;
      this.noMoreItem = false;
      this.countLazyLoading = 0;
      this.learningUnits = [];
    },

    async loadLearningUnit() {
      if (this.isLoadMore || this.noMoreItem) return;
      let start = 0;
      let limit = this.pageSize;
      if (this.countLazyLoading > 0) start = this.pageSize * this.countLazyLoading;
      await this.fetchLearningUnits(start, limit);
    },

    /**
     * Fetching more learning units with or without filter
     * @param {start} Number data index for start fetching
     * @param {limit} Number limit amount of datas for fetching
     */
    async fetchLearningUnits(start, limit) {
      try {
        this.isLoadMore = true;
        const { response } = await LearningUnit.api().fetchExplore(this.fetchParams, start, limit);
        if (response.data?.length) {
          const moreLearningUnits = response.data;

          this.learningUnits = [...this.learningUnits, ...moreLearningUnits];
          this.countLazyLoading++;
        } else {
          this.noMoreItem = true;
          if (start == 0) {
            this.hasSearchResult = false;
          }
          return;
        }
      } catch (error) {
        this.noMoreItem = true;
        console.error(error);
      } finally {
        setTimeout(() => {
          this.isLoadMore = false;
        }, 1000);
      }
    },

    async fetchCategories() {
      try {
        await Category.api().fetch();
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss"></style>
